/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * @file  BehaviourTrendsStyle.jsx
 * Styles for behaviour trends card on difficult topic review
 */

import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../../assets/styles/mixins.scss';

const useBehaviorTrendsStyles = makeStyles(() => ({
  root: {
    border: `1px solid ${mixins.chalkWhiteFont}`,
    borderRadius: 16,
    padding: 16,
    backgroundColor: mixins.chalkWhiteFont,
    height: '100%',
    boxSizing: 'border-box'
  },
  title: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight500,
    fontStyle: 'normal',
    fontSize: mixins.fontSize20,
    lineHeight: '28px',
    letterSpacing: '-0.4',
    color: mixins.color_text_primary,
    marginBottom: 16
  },
  trendsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  trendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 16
  },
  percentText: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight600,
    fontStyle: 'normal',
    fontSize: mixins.fontSize16,
    lineHeight: '100%',
    color: mixins.color_text_primary
  },
  trendText: {
    display: 'flex',
    flexDirection: 'column'
  },
  valueText: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight500,
    fontStyle: 'normal',
    fontSize: mixins.fontSize14,
    lineHeight: mixins.lineHeight22,
    color: mixins.amethyst
  },
  descriptionText: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight400,
    fontStyle: 'normal',
    fontSize: mixins.fontSize12,
    lineHeight: mixins.lineHeight20,
    color: mixins.color_text_primary
  }
}));

export default useBehaviorTrendsStyles;
